import React, { useEffect, useState } from 'react';
import './Media.css';

import data from './mediaData';
import Slider from './Slider';

import { useSwipeable } from 'react-swipeable';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';

function Media({ width }) {
  const [index, setIndex] = useState(0);
  const [news] = useState(data);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleNext(),
    onSwipedRight: () => handlePrev(),
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  const handleNext = () => {
    setIndex(prevIndex => (prevIndex + 1) % news.length);
  };

  const handlePrev = () => {
    setIndex(prevIndex => (prevIndex - 1 + news.length) % news.length);
  };

  return (
    <div className="media-container" id="Media">
      <div className="media__headline--wrapper" data-aos="flip-left">
        <h2 className="media__title">Media ABOUT US</h2>
      </div>
      <div className="media__content--wrapper" data-aos="fade-right">
        <div className="media__news--container" {...swipeHandlers}>
          <div className="media__btn btn--prev" onClick={handlePrev}>
            <AiOutlineLeft />
          </div>
          <div className="media__article">
            {news.map((article, articleIndex) => (
              <Slider 
                key={article.id} 
                {...article} 
                index={index}
                articleIndex={articleIndex}
                totalItems={news.length}
              />
            ))}
          </div>
          <div className="media__btn btn--next" onClick={handleNext}>
            <AiOutlineRight />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Media;